import {createSelector} from 'reselect';
import getThreeDSecureData from './getThreeDSecureData';

export default createSelector(
  [getThreeDSecureData],
  (threeDSecureData => threeDSecureData?.collect),
);
